import { node } from "prop-types";
import { createContext, useState } from "react";

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [sideNavCollapsed, setSideNavCollapsed] = useState(true);

  const toggleSideNav = () => setSideNavCollapsed(!sideNavCollapsed);

  return (
    <NavigationContext.Provider
      value={{
        sideNavCollapsed,
        toggleSideNav,
        setSideNavCollapsed,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

NavigationProvider.propTypes = {
  children: node.isRequired,
};
